import { ButtonContentfulModel } from 'src/api/models/Button';
import { CaseStudyHighlightContentfulModel } from 'src/api/models/CaseStudyHighlight';
import { CheckedItemContentfulModel } from 'src/api/models/CheckedItem';
import { ChecklistContentfulModel } from 'src/api/models/Checklist';
import { ClientShowCaseListContentfulModel } from 'src/api/models/ClientsShowCase';
import { ComparisonTableContentfulModel } from 'src/api/models/ComparisonTable';
import { CreatorSliderContentfulModel } from 'src/api/models/CreatorsSlider';
import { FaqContainerContentfulModel } from 'src/api/models/Faq';
import { FeatureListContentfulModel } from 'src/api/models/FeatureList';
import { HeadingContentfulModel } from 'src/api/models/Heading';
import { HeroBannerContentfulModel } from 'src/api/models/HeroBanner';
import { HeroBannerProContentfulModel } from 'src/api/models/HeroBannerPro';
import { HighlightMetricsContentfulModel } from 'src/api/models/HighlightMetrics';
import { ImageContentfulModel } from 'src/api/models/Image';
import { OrderedListContentfulModel } from 'src/api/models/OrderedList';
import { PhoneCarouselContentfulModel } from 'src/api/models/PhoneCarousel';
import { ShortParagraphContentModel } from 'src/api/models/ShortParagraph';
import { TrustedByContentfulModel } from 'src/api/models/TrustedBy';
import getDynamicButton from './Button.dynamic';
import getDynamicCaseStudyHighlight from './CaseStudyHighlight';
import getDynamicCheckedItem from './CheckedItem.dynamic';
import getDynamicChecklist from './Checklist.dynamic';
import getDynamicClientShowCaseList from './ClientShowCase.dynamic';
import getDynamicComparisonTable from './ComparisonTable.dynamic';
import getDynamicCreatorsSlider from './CreatorsImages.dynamic';
import getDynamicFAQList from './FAQList.dynamic';
import getDynamicFeatures from './Features.dynamic';
import getDynamicHeading from './Heading.dynamic';
import getDynamicHeroBanner from './HeroBanner.dynamic';
import getDynamicHeroBannerPro from './HeroBannerPro.dynamic';
import getDynamicHighlightMetrics from './HighlightMetrics.dynamic';
import getDynamicImage from './Image.dyamic';
import getDynamicOrderedListSection from './OrderedListSection.dynamic';
import getDynamicPhoneCarousel from './PhoneCarousel.dynamic';
import getDynamicRatings from './Ratings.dynamic';
import getDynamicShortParagraph from './ShortParagraph.dynamic';
import getDynamicTrustedBy from './TrustedBy.dynamic';

interface DynamicComponentsModel {
  [key: string]: (props: unknown) => React.ReactNode;
}

const dynamicComponent: DynamicComponentsModel = {
  ContentfulHeading: (props) => getDynamicHeading(props as HeadingContentfulModel),
  ContentfulPhoneCarousel: (props) => getDynamicPhoneCarousel(props as PhoneCarouselContentfulModel),
  ContentfulButton: (props) => getDynamicButton(props as ButtonContentfulModel),
  ContentfulTrustedClients: (props) => getDynamicTrustedBy(props as TrustedByContentfulModel),
  ContentfulHeroBanner: (props) => getDynamicHeroBanner(props as HeroBannerContentfulModel),
  ContentfulFeatures: (props) => getDynamicFeatures(props as FeatureListContentfulModel),
  ContentfulFaq: (props) => getDynamicFAQList(props as FaqContainerContentfulModel),
  ContentfulOrderedList: (props) => getDynamicOrderedListSection(props as OrderedListContentfulModel),
  ContentfulHeroBannerPro: (props) => getDynamicHeroBannerPro(props as HeroBannerProContentfulModel),
  ContentfulShortParagraph: (props) => getDynamicShortParagraph(props as ShortParagraphContentModel),
  ContentfulImage: (props) => getDynamicImage(props as ImageContentfulModel),
  ContentfulRatings: () => getDynamicRatings(),
  ContentfulSlider: (props) => getDynamicCreatorsSlider(props as CreatorSliderContentfulModel),
  ContentfulCheckedItem: (props) => getDynamicCheckedItem(props as CheckedItemContentfulModel),
  ContentfulChecklist: (props) => getDynamicChecklist(props as ChecklistContentfulModel),
  ContentfulHighlightMetrics: (props) => getDynamicHighlightMetrics(props as HighlightMetricsContentfulModel),
  ContentfulCaseStudyHighlight: (props) => getDynamicCaseStudyHighlight(props as CaseStudyHighlightContentfulModel),
  ContentfulComparisonTable: (props) => getDynamicComparisonTable(props as ComparisonTableContentfulModel),
  ContentfulClientShowCaseList: (props) => getDynamicClientShowCaseList(props as ClientShowCaseListContentfulModel)
}

export default dynamicComponent;
